<template>
    <div class="tsa-conditionSearchV2" :class="clearable && inputValue ? 'active' : ''">
        <el-input :placeholder="placeholder" v-model="inputValue" @input="input" @keyup.native.enter="change" :maxlength="maxlength" pattern="[A-Za-z0-9]*">
            <i slot="suffix" v-if="clearable" class="el-icon-circle-close" @click="close"></i>
            <i slot="suffix" v-if="icon" :style="{ 'cursor': !clearable ?  'pointer' : 'default' }" class="tsa-icon-search2" @click="change"></i>
        </el-input>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请输入'
        },
        maxlength: {
            type: Number,
            default: 30
        },
        clearable: {
            type: Boolean,
            default: false
        },
        icon: {
            type: Boolean,
            default: false
        },
        format: {
            type: RegExp | String,
            default: ''
        }
    },
    data () {
        return {
            inputValue: ''
        }
    },
    watch: {
        value (val) {
            this.inputValue = val
        }
    },
    created () {
        this.inputValue = this.value
    },
    methods: {
        input (e) {
            if (this.inputValue) {
                this.inputValue = this.inputValue.trim()
                if (this.format) {
                    this.inputValue = this.inputValue.replace(this.format, '')
                }
                this.$emit('input', this.inputValue)
            } else {
                this.$emit('input', null)
            }
            
        },
        change () {
            if (this.inputValue) {
                let inputValue = this.inputValue.trim()
                this.$emit('input', inputValue)
                this.$emit('on-search', inputValue)
            } else {
                this.$emit('input', null)
                this.$emit('on-search', null)
            }
        },
        close () {
            this.$emit('input', null)
            this.$emit('on-search', null)
        },
    },
}
</script>

<style lang="scss" scoped>
    .tsa-conditionSearchV2 {
        &.active {
            &:hover {
                .el-icon-circle-close {
                    display: block!important;
                }
                .tsa-icon-search2 {
                    display: none;
                }
            }
        }
        /deep/.el-input{
            .el-input__inner {
                font-size:  14px;
                color: #151B26;
                border: 1px solid #D4D6D9;
                border-radius: 6px;
                height: 32px;
                line-height: 32px;
                &:focus {
                    border-color: #2468F2;
                }
                &::placeholder {
                    color: #B8BABF;
                }
            }
            .el-input__suffix {
                display: flex;
                align-items: center;
                margin-right: 4px;
                .el-input__suffix-inner {
                    .el-icon-circle-close {
                        cursor: pointer;
                        display: none;
                    }
                }
            }
        }
    }
</style>